// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var Status_Enum;
(function (Status_Enum) {
    Status_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    Status_Enum["HIDDEN_DRAFT"] = "HIDDEN_DRAFT";
    Status_Enum["DRAFT"] = "DRAFT";
    Status_Enum["SCHEDULED"] = "SCHEDULED";
    Status_Enum["PROCESSING"] = "PROCESSING";
    Status_Enum["COMPLETED"] = "COMPLETED";
    Status_Enum["CANCELED"] = "CANCELED";
    Status_Enum["DELETED"] = "DELETED";
    Status_Enum["FAILED"] = "FAILED";
})(Status_Enum || (Status_Enum = {}));
export var Status_Enum_index;
(function (Status_Enum_index) {
    Status_Enum_index[Status_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    Status_Enum_index[Status_Enum_index["HIDDEN_DRAFT"] = 1] = "HIDDEN_DRAFT";
    Status_Enum_index[Status_Enum_index["DRAFT"] = 2] = "DRAFT";
    Status_Enum_index[Status_Enum_index["SCHEDULED"] = 3] = "SCHEDULED";
    Status_Enum_index[Status_Enum_index["PROCESSING"] = 4] = "PROCESSING";
    Status_Enum_index[Status_Enum_index["COMPLETED"] = 5] = "COMPLETED";
    Status_Enum_index[Status_Enum_index["CANCELED"] = 6] = "CANCELED";
    Status_Enum_index[Status_Enum_index["DELETED"] = 7] = "DELETED";
    Status_Enum_index[Status_Enum_index["FAILED"] = 8] = "FAILED";
})(Status_Enum_index || (Status_Enum_index = {}));
export var CampaignType_Enum;
(function (CampaignType_Enum) {
    CampaignType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    CampaignType_Enum["EMAIL"] = "EMAIL";
    CampaignType_Enum["SMS"] = "SMS";
})(CampaignType_Enum || (CampaignType_Enum = {}));
export var CampaignType_Enum_index;
(function (CampaignType_Enum_index) {
    CampaignType_Enum_index[CampaignType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    CampaignType_Enum_index[CampaignType_Enum_index["EMAIL"] = 1] = "EMAIL";
    CampaignType_Enum_index[CampaignType_Enum_index["SMS"] = 2] = "SMS";
})(CampaignType_Enum_index || (CampaignType_Enum_index = {}));
